"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var render_exports = {};
__export(render_exports, {
  renderBpmnDiagram: () => renderBpmnDiagram,
  renderBpmnLayout: () => renderBpmnLayout,
  renderBpmnToSvg: () => renderBpmnToSvg
});
module.exports = __toCommonJS(render_exports);
var import_layout = require("./layout");
var import_parser = require("./parser");
const colors = {
  stroke: "var(--theme-content-color, #555a6b)",
  strongStroke: "var(--theme-caption-color, #1f212b)",
  fill: "var(--theme-bg-color, #ffffff)",
  accentFill: "var(--theme-button-default, #f4f5f8)",
  text: "var(--theme-caption-color, #1f212b)",
  mutedText: "var(--theme-content-color, #555a6b)"
};
function escapeXml(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
__name(escapeXml, "escapeXml");
function round(value) {
  return (Math.round(value * 100) / 100).toString();
}
__name(round, "round");
function style(declarations) {
  const value = Object.entries(declarations).map(([property, v]) => `${property}:${v}`).join(";");
  return `style="${value}"`;
}
__name(style, "style");
const outlineStyle = style({ fill: colors.fill, stroke: colors.stroke });
const strongOutlineStyle = style({ fill: colors.fill, stroke: colors.strongStroke });
const bodyStyle = style({ fill: colors.accentFill, stroke: colors.stroke });
const lineStyle = style({ fill: "none", stroke: colors.stroke });
const poolFrameStyle = style({ fill: "none", stroke: colors.strongStroke });
const poolHeaderStyle = style({ fill: colors.accentFill, stroke: colors.strongStroke });
const laneFrameStyle = style({ fill: "none", stroke: colors.stroke });
const laneHeaderStyle = style({ fill: colors.accentFill, stroke: colors.stroke });
function shapeCenter(shape) {
  return { cx: shape.x + shape.width / 2, cy: shape.y + shape.height / 2 };
}
__name(shapeCenter, "shapeCenter");
function circle(cx, cy, r, shapeStyle, strokeWidth) {
  return `<circle cx="${round(cx)}" cy="${round(cy)}" r="${round(r)}" stroke-width="${strokeWidth}" ${shapeStyle}/>`;
}
__name(circle, "circle");
function renderShapeBody(shape) {
  const { cx, cy } = shapeCenter(shape);
  const r = shape.width / 2;
  switch (shape.kind) {
    case "startEvent":
      return circle(cx, cy, r, outlineStyle, 2);
    case "endEvent":
      return circle(cx, cy, r, strongOutlineStyle, 4);
    case "intermediateEvent":
      return circle(cx, cy, r, outlineStyle, 2) + circle(cx, cy, r - 4, lineStyle, 2);
    case "gateway": {
      const points = [
        `${round(cx)},${round(shape.y)}`,
        `${round(shape.x + shape.width)},${round(cy)}`,
        `${round(cx)},${round(shape.y + shape.height)}`,
        `${round(shape.x)},${round(cy)}`
      ].join(" ");
      return `<polygon points="${points}" stroke-width="2" ${outlineStyle}/>${gatewayMarker(shape, cx, cy)}`;
    }
    case "subProcess":
      return box(shape) + subProcessMarker(shape, cx);
    default:
      return box(shape) + taskMarker(shape);
  }
}
__name(renderShapeBody, "renderShapeBody");
function box(shape) {
  return `<rect x="${round(shape.x)}" y="${round(shape.y)}" width="${round(shape.width)}" height="${round(shape.height)}" rx="8" stroke-width="2" ${bodyStyle}/>`;
}
__name(box, "box");
function gatewayMarker(shape, cx, cy) {
  if (shape.gateway === "or") {
    return circle(cx, cy, 9, lineStyle, 2);
  }
  const d = shape.gateway === "and" ? `M ${round(cx - 10)} ${round(cy)} H ${round(cx + 10)} M ${round(cx)} ${round(cy - 10)} V ${round(cy + 10)}` : `M ${round(cx - 7)} ${round(cy - 7)} L ${round(cx + 7)} ${round(cy + 7)} M ${round(cx + 7)} ${round(cy - 7)} L ${round(cx - 7)} ${round(cy + 7)}`;
  return `<path d="${d}" stroke-width="2" ${lineStyle}/>`;
}
__name(gatewayMarker, "gatewayMarker");
function subProcessMarker(shape, cx) {
  const bottom = shape.y + shape.height;
  return `<rect x="${round(cx - 7)}" y="${round(bottom - 17)}" width="14" height="14" stroke-width="1.5" ${lineStyle}/><path d="M ${round(cx - 4)} ${round(bottom - 10)} H ${round(cx + 4)} M ${round(cx)} ${round(bottom - 14)} V ${round(bottom - 6)}" stroke-width="1.5" ${lineStyle}/>`;
}
__name(subProcessMarker, "subProcessMarker");
function taskMarker(shape) {
  const x = shape.x + 8;
  const y = shape.y + 8;
  if (shape.kind === "userTask") {
    return circle(x + 6, y + 4, 3, lineStyle, 1.5) + `<path d="M ${round(x + 1)} ${round(y + 13)} a 5 5 0 0 1 10 0" stroke-width="1.5" ${lineStyle}/>`;
  }
  if (shape.kind === "serviceTask") {
    return circle(x + 6, y + 7, 5, lineStyle, 1.5) + circle(x + 6, y + 7, 1.5, lineStyle, 1.5);
  }
  return "";
}
__name(taskMarker, "taskMarker");
function renderShapeLabel(shape) {
  if (shape.labelLines.length === 0) return "";
  const { lineHeight, fontSize, labelGap } = import_layout.bpmnMetrics;
  const { cx } = shapeCenter(shape);
  const inside = shape.labelPlacement === "inside";
  const blockHeight = shape.labelLines.length * lineHeight;
  const top = inside ? shape.y + shape.height / 2 - blockHeight / 2 : shape.y + shape.height + labelGap;
  const tspans = shape.labelLines.map((line, index) => {
    const y = top + index * lineHeight + lineHeight / 2 + fontSize / 3;
    return `<tspan x="${round(cx)}" y="${round(y)}">${escapeXml(line)}</tspan>`;
  }).join("");
  const textStyle = style({ fill: inside ? colors.text : colors.mutedText });
  return `<text text-anchor="middle" xml:space="preserve" font-size="${fontSize}" ${textStyle}>${tspans}</text>`;
}
__name(renderShapeLabel, "renderShapeLabel");
function rect(x, y, width, height, rectStyle) {
  return `<rect x="${round(x)}" y="${round(y)}" width="${round(width)}" height="${round(height)}" stroke-width="1.5" ${rectStyle}/>`;
}
__name(rect, "rect");
function rotatedLabel(label, x, y, width, height) {
  const text = label.trim();
  if (text.length === 0) return "";
  const cx = x + width / 2;
  const cy = y + height / 2;
  const available = height - 2 * import_layout.bpmnMetrics.lanePadding;
  const natural = text.length * import_layout.bpmnMetrics.charWidth;
  const squeeze = available > 0 && natural > available ? `textLength="${round(available)}" lengthAdjust="spacingAndGlyphs" ` : "";
  return `<text x="${round(cx)}" y="${round(cy + import_layout.bpmnMetrics.fontSize / 3)}" text-anchor="middle" transform="rotate(-90 ${round(cx)} ${round(cy)})" font-size="${import_layout.bpmnMetrics.fontSize}" ${squeeze}${style({ fill: colors.text })}>${escapeXml(text)}</text>`;
}
__name(rotatedLabel, "rotatedLabel");
function renderPool(pool) {
  return '<g class="bpmn-pool">' + rect(pool.x, pool.y, pool.width, pool.height, poolFrameStyle) + rect(pool.x, pool.y, pool.headerWidth, pool.height, poolHeaderStyle) + rotatedLabel(pool.label, pool.x, pool.y, pool.headerWidth, pool.height) + "</g>";
}
__name(renderPool, "renderPool");
function renderLane(lane) {
  const separator = lane.separator ? `<path d="M ${round(lane.x)} ${round(lane.y)} H ${round(lane.x + lane.width)}" stroke-width="1.5" ${laneFrameStyle}/>` : "";
  return '<g class="bpmn-lane">' + separator + rect(lane.x, lane.y, lane.headerWidth, lane.height, laneHeaderStyle) + rotatedLabel(lane.label, lane.x, lane.y, lane.headerWidth, lane.height) + "</g>";
}
__name(renderLane, "renderLane");
function renderEdge(edge, markerId, dashed = false, edgeClass) {
  if (edge.points.length === 0) return "";
  const [first, ...rest] = edge.points;
  const d = [`M ${round(first.x)} ${round(first.y)}`, ...rest.map((p) => `L ${round(p.x)} ${round(p.y)}`)].join(" ");
  const dash = dashed ? 'stroke-dasharray="6 4" ' : "";
  const className = edgeClass !== void 0 ? `class="${edgeClass}" ` : "";
  const path = `<path ${className}d="${d}" stroke-width="1.5" stroke-linejoin="round" ${dash}marker-end="url(#${markerId})" ${lineStyle}/>`;
  if (edge.label === void 0 || edge.label.length === 0 || edge.labelPosition === void 0) {
    return path;
  }
  return path + renderEdgeLabel(edge.label, edge.labelPosition, edge.labelLines);
}
__name(renderEdge, "renderEdge");
function renderEdgeLabel(label, position, lines) {
  const { x, y } = position;
  const textStyle = style({ fill: colors.mutedText });
  const open = `<text x="${round(x)}" y="${round(y)}" text-anchor="middle" xml:space="preserve" font-size="${import_layout.bpmnMetrics.fontSize - 1}" ${textStyle}>`;
  if (lines === void 0 || lines.length <= 1) {
    return `${open}${escapeXml((lines?.[0] ?? label).trim())}</text>`;
  }
  const tspans = lines.map((line, index) => {
    const lineY = y - (lines.length - 1 - index) * import_layout.bpmnMetrics.lineHeight;
    return `<tspan x="${round(x)}" y="${round(lineY)}">${escapeXml(line)}</tspan>`;
  }).join("");
  return `${open}${tspans}</text>`;
}
__name(renderEdgeLabel, "renderEdgeLabel");
function renderMessageEdge(edge, markerId) {
  return renderEdge(edge, markerId, edge.dashed, "bpmn-message-flow");
}
__name(renderMessageEdge, "renderMessageEdge");
function renderBpmnLayout(layout, options = {}) {
  const prefix = options.idPrefix ?? "bpmn";
  const markerId = `${prefix}-arrow`;
  const messageMarkerId = `${prefix}-message-arrow`;
  const title = layout.title !== void 0 ? `<text x="${round(import_layout.bpmnMetrics.padding)}" y="${round(import_layout.bpmnMetrics.padding + 8)}" font-size="15" font-weight="600" ${style({ fill: colors.text })}>${escapeXml(layout.title)}</text>` : "";
  const openHead = layout.messageEdges.length > 0 ? `<marker id="${messageMarkerId}" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse"><path d="M 0 0 L 10 5 L 0 10" stroke-width="1.5" ${lineStyle}/></marker>` : "";
  const defs = `<defs><marker id="${markerId}" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M 0 0 L 10 5 L 0 10 z" ${style({ fill: colors.stroke })}/></marker>${openHead}</defs>`;
  const pools = layout.pools.map(renderPool).join("");
  const lanes = layout.lanes.map(renderLane).join("");
  const edges = layout.edges.map((edge) => renderEdge(edge, markerId)).join("");
  const messageEdges = layout.messageEdges.map((edge) => renderMessageEdge(edge, messageMarkerId)).join("");
  const shapes = layout.shapes.map((shape) => renderShapeBody(shape) + renderShapeLabel(shape)).join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" class="bpmn-diagram-svg" role="img" viewBox="0 0 ${round(layout.width)} ${round(layout.height)}" width="${round(layout.width)}" height="${round(layout.height)}" ${style({ "font-family": "var(--font-family), sans-serif" })}>${defs}${title}${pools}${lanes}${edges}${messageEdges}${shapes}</svg>`;
}
__name(renderBpmnLayout, "renderBpmnLayout");
function renderBpmnDiagram(diagram, options = {}) {
  return renderBpmnLayout((0, import_layout.layoutBpmn)(diagram), options);
}
__name(renderBpmnDiagram, "renderBpmnDiagram");
function renderBpmnToSvg(source, options = {}) {
  if ((0, import_parser.isBpmnSourceEmpty)(source)) {
    return { empty: true };
  }
  const result = (0, import_parser.parseBpmn)(source);
  if (result.error !== void 0) {
    return { error: result.error };
  }
  if (result.diagram.elements.length === 0 && result.diagram.pools.length === 0) {
    return { empty: true };
  }
  try {
    return { svg: renderBpmnDiagram(result.diagram, options) };
  } catch (err) {
    const message = err instanceof Error ? err.message : "Unable to render the diagram.";
    return { error: { message, line: 1 } };
  }
}
__name(renderBpmnToSvg, "renderBpmnToSvg");
//# sourceMappingURL=render.js.map
